module.exports = __webpack_public_path__ + "media/images/pages/img_close_profile_dummy-85ef706822784b1ce337813becf3de4c.png";